import { slice } from '@imcc/utilities';
import { AppState } from './app-state';
import { CollectionState } from './features/collections/collection-state.interface';
import { initialState as initialSearchState, SearchState } from './features/search/search-state';

export class LocalStorageAppState {
  constructor(private state: AppState) {}

  toObject(): {
    search: ReturnType<LocalStorageAppState['buildSearchState']>;
    collection: ReturnType<LocalStorageAppState['buildCollectionState']>;
    user: ReturnType<LocalStorageAppState['buildUserState']>;
  } {
    return {
      search: this.buildSearchState(),
      collection: this.buildCollectionState(),
      user: this.buildUserState(),
    };
  }

  private buildUserState() {
    return this.state.user;
  }

  private buildCollectionState() {
    return this.state.collection || new CollectionState();
  }

  private buildSearchState() {
    const searchState = this.state.search || { ...initialSearchState };

    return {
      thumbnailSize: searchState.thumbnailSize,
      tabs: LocalStorageAppState.buildTabs(searchState),
    };
  }

  private static buildTabs(state: SearchState) {
    return Object.entries(state.tabs).reduce(
      (acc, [index, tab]) => ({
        ...acc,
        [index]: slice(tab, 'sortTerm', 'order'),
      }),
      {},
    );
  }
}
